import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
export default function SelectedResources(_ref) {
  var resources = _ref.resources;
  return /*#__PURE__*/React.createElement("ul", {
    className: "share-drawer-list share-drawer__share-form"
  }, resources.map(function (_ref2) {
    var id = _ref2.id,
      name = _ref2.name;
    return /*#__PURE__*/React.createElement("li", {
      key: id,
      "data-testid": "share-resource-".concat(id),
      className: "share-drawer-list-item"
    }, name);
  }));
}
SelectedResources.propTypes = {
  resources: arrayOf(shape({
    id: string,
    name: string
  })).isRequired
};
//# sourceMappingURL=SelectedResources.js.map